import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section background="white" data-id="element-12">
      <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-13">
        {/* For You */}
        <div data-id="element-14">
          <h3 className="text-xl font-serif font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-15">
            <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded-lg text-xs font-sans uppercase tracking-wide" data-id="element-16">
              Es para ti si
            </span>
          </h3>
          <ul className="space-y-3" data-id="element-17">
            {['Quieres mejorar la comunicación sin volverte su terapeuta', 'Te duele sentir esa distancia fría con tus papás', 'Te cansas de discusiones por tonterías repetidas', 'Quieres frases reales para WhatsApp, llamadas y cara a cara'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-18">
                <Check className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" data-id="element-19" />
                <span className="text-stone-700 text-sm" data-id="element-20">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div data-id="element-21">
          <h3 className="text-xl font-serif font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-22">
            <span className="bg-stone-200 text-stone-600 px-2 py-0.5 rounded-lg text-xs font-sans uppercase tracking-wide" data-id="element-23">
              No es para ti si
            </span>
          </h3>
          <ul className="space-y-3" data-id="element-24">
            {["Buscas 'cambiar' a tus padres a la fuerza", 'Quieres soluciones mágicas sin practicar al menos 7 días', 'Hay violencia o riesgo físico (ahí toca apoyo profesional)', 'Esperas que ellos hagan todo el trabajo primero'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-25">
                <X className="w-4 h-4 text-stone-400 mt-0.5 flex-shrink-0" data-id="element-26" />
                <span className="text-stone-500 text-sm" data-id="element-27">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}